var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLove({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2172 29.2015C15.7521 29.5 16.3958 29.4835 16.9277 29.1795C20.5107 27.1318 26.737 22.4179 29.1823 16.2948C32.7714 8.3224 24.3442 1.95834 18.5199 6.5356C17.9123 7.01307 17.1484 7.55954 16.6227 8.07719C16.385 8.31124 15.9661 8.33511 15.7194 8.11061C15.0282 7.48177 13.9481 6.67511 13.2543 6.20577C8.28898 2.84639 -0.745633 7.27463 3.10821 16.7255C4.51997 20.9677 11.2475 26.9862 15.2172 29.2015Z",
    fill: "url(#paint0_radial_1273_4742)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2172 29.2015C15.7521 29.5 16.3958 29.4835 16.9277 29.1795C20.5107 27.1318 26.737 22.4179 29.1823 16.2948C32.7714 8.3224 24.3442 1.95834 18.5199 6.5356C17.9123 7.01307 17.1484 7.55954 16.6227 8.07719C16.385 8.31124 15.9661 8.33511 15.7194 8.11061C15.0282 7.48177 13.9481 6.67511 13.2543 6.20577C8.28898 2.84639 -0.745633 7.27463 3.10821 16.7255C4.51997 20.9677 11.2475 26.9862 15.2172 29.2015Z",
    fill: "url(#paint1_radial_1273_4742)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2172 29.2015C15.7521 29.5 16.3958 29.4835 16.9277 29.1795C20.5107 27.1318 26.737 22.4179 29.1823 16.2948C32.7714 8.3224 24.3442 1.95834 18.5199 6.5356C17.9123 7.01307 17.1484 7.55954 16.6227 8.07719C16.385 8.31124 15.9661 8.33511 15.7194 8.11061C15.0282 7.48177 13.9481 6.67511 13.2543 6.20577C8.28898 2.84639 -0.745633 7.27463 3.10821 16.7255C4.51997 20.9677 11.2475 26.9862 15.2172 29.2015Z",
    fill: "url(#paint2_radial_1273_4742)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2172 29.2015C15.7521 29.5 16.3958 29.4835 16.9277 29.1795C20.5107 27.1318 26.737 22.4179 29.1823 16.2948C32.7714 8.3224 24.3442 1.95834 18.5199 6.5356C17.9123 7.01307 17.1484 7.55954 16.6227 8.07719C16.385 8.31124 15.9661 8.33511 15.7194 8.11061C15.0282 7.48177 13.9481 6.67511 13.2543 6.20577C8.28898 2.84639 -0.745633 7.27463 3.10821 16.7255C4.51997 20.9677 11.2475 26.9862 15.2172 29.2015Z",
    fill: "url(#paint3_radial_1273_4742)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2172 29.2015C15.7521 29.5 16.3958 29.4835 16.9277 29.1795C20.5107 27.1318 26.737 22.4179 29.1823 16.2948C32.7714 8.3224 24.3442 1.95834 18.5199 6.5356C17.9123 7.01307 17.1484 7.55954 16.6227 8.07719C16.385 8.31124 15.9661 8.33511 15.7194 8.11061C15.0282 7.48177 13.9481 6.67511 13.2543 6.20577C8.28898 2.84639 -0.745633 7.27463 3.10821 16.7255C4.51997 20.9677 11.2475 26.9862 15.2172 29.2015Z",
    fill: "url(#paint4_linear_1273_4742)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2172 29.2015C15.7521 29.5 16.3958 29.4835 16.9277 29.1795C20.5107 27.1318 26.737 22.4179 29.1823 16.2948C32.7714 8.3224 24.3442 1.95834 18.5199 6.5356C17.9123 7.01307 17.1484 7.55954 16.6227 8.07719C16.385 8.31124 15.9661 8.33511 15.7194 8.11061C15.0282 7.48177 13.9481 6.67511 13.2543 6.20577C8.28898 2.84639 -0.745633 7.27463 3.10821 16.7255C4.51997 20.9677 11.2475 26.9862 15.2172 29.2015Z",
    fill: "url(#paint5_linear_1273_4742)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2172 29.2015C15.7521 29.5 16.3958 29.4835 16.9277 29.1795C20.5107 27.1318 26.737 22.4179 29.1823 16.2948C32.7714 8.3224 24.3442 1.95834 18.5199 6.5356C17.9123 7.01307 17.1484 7.55954 16.6227 8.07719C16.385 8.31124 15.9661 8.33511 15.7194 8.11061C15.0282 7.48177 13.9481 6.67511 13.2543 6.20577C8.28898 2.84639 -0.745633 7.27463 3.10821 16.7255C4.51997 20.9677 11.2475 26.9862 15.2172 29.2015Z",
    fill: "url(#paint6_radial_1273_4742)",
    fillOpacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1273_4742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9082 10.5408V17.3635C15.9082 18.2684 17.0038 18.6973 17.5679 17.9897C19.313 15.8007 20.7206 13.1389 19.1498 10.9647C18.5475 10.131 17.3938 9.59695 16.451 9.76686C16.0983 9.83043 15.9082 10.1824 15.9082 10.5408Z",
    fill: "#FA1C56"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1273_4742)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.6631,
    cy: 11.3771,
    rx: 4.46173,
    ry: 3.70012,
    transform: "rotate(-44.1901 24.6631 11.3771)",
    fill: "url(#paint7_radial_1273_4742)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1273_4742)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.4602,
    cy: 6.0669,
    rx: 1.69254,
    ry: 0.355636,
    transform: "rotate(7.16522 23.4602 6.0669)",
    fill: "#FF7383"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1273_4742)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.38876,
    cy: 6.05318,
    rx: 1.51865,
    ry: 0.249413,
    transform: "rotate(-0.697201 9.38876 6.05318)",
    fill: "#FF93BA",
    fillOpacity: 0.5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1273_4742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.845 9.96199L15.1575 20.212C8.28253 13.5245 6.96052 8.82825 9.59497 7.77449C12.095 6.77449 14.095 8.39949 14.845 9.96199Z",
    fill: "url(#paint8_radial_1273_4742)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1273_4742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3447 9.36191C13.5047 9.24191 13.2447 8.54525 13.2197 8.21191C13.6997 8.71191 14.1697 8.75358 14.3447 8.71191V9.36191Z",
    fill: "#FF7383"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1273_4742",
    x: 13.9082,
    y: 7.73535,
    width: 7.92285,
    height: 12.6084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1273_4742"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1273_4742",
    x: 19.0537,
    y: 5.78906,
    width: 11.2188,
    height: 11.1758,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_1273_4742"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1273_4742",
    x: 19.7803,
    y: 3.65527,
    width: 7.35938,
    height: 4.82324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1273_4742"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1273_4742",
    x: 6.37012,
    y: 4.30273,
    width: 6.03711,
    height: 3.50098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_1273_4742"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1273_4742",
    x: 5.33301,
    y: 4.4668,
    width: 12.8242,
    height: 18.7451,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_1273_4742"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1273_4742",
    x: 12.2197,
    y: 7.21191,
    width: 3.125,
    height: 3.15039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1273_4742"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1273_4742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.8829 5.63363) rotate(90) scale(22.9845 24.4021)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527969,
    stopColor: "#FF3B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F724B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1273_4742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.025 11.3631) rotate(134.402) scale(21.2647 39.8308)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.797874,
    stopColor: "#C82092",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908039,
    stopColor: "#C82092"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1273_4742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.9969 17.7886) rotate(-158.663) scale(22.749 32.159)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.40984,
    stopColor: "#B91D43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833898,
    stopColor: "#B91D43"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1273_4742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.5603 13.8155) rotate(90) scale(19.7992)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.671096,
    stopColor: "#FF7AF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933555,
    stopColor: "#FFBCE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1273_4742",
    x1: 17.7455,
    y1: 16.1331,
    x2: 25.7578,
    y2: 25.6685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.694491,
    stopColor: "#FF7AF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933555,
    stopColor: "#FFBCE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1273_4742",
    x1: 16.7522,
    y1: 16.5304,
    x2: 7.34924,
    y2: 27.1253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.694491,
    stopColor: "#FF7AF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933555,
    stopColor: "#FFBCE6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1273_4742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.3472 12.8957) rotate(164.618) scale(17.2146 18.1802)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#FF73A6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF93BA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1273_4742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.1198 11.2517) rotate(172.927) scale(7.29137 9.69562)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7383",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1273_4742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.345 13.8394) rotate(-135.591) scale(12.6861 22.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6274",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.8ae6ed8a6bbfa2469125a27fd7aeac73.svg";
export { ForwardRef as ReactComponent };